export default __webpack_public_path__ + "static/media/TypeScript.7fd39274.png";